module.exports = __webpack_public_path__ + "static/img/Frame_4407@2x.2a282bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bloodPressure/Frame_4407@2x.png
// module id = ae/D
// module chunks = 64